export default __webpack_public_path__ + "static/media/GoodMannersWithYourSiblings_05.728f78f8.png";